import {Injectable} from "@angular/core";
import {ApiService} from "./api/api-service";
import {Observable} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ShoppingHistoryService {
    private CONTROLLER = "/nop/ShoppingHistory/";
    private SAVE_PAGE_ACTION = this.CONTROLLER + "SaveLastShoppingPage/";

    public constructor(private apiService: ApiService) {
    }

    public saveCurrentPage(): Observable<boolean> {
        return this.apiService.get<boolean>(this.SAVE_PAGE_ACTION, {pageUrl: window.location.href});
    }
}
